<script>
  import {supabase} from "../routes/api/supabase.js"
  import {goto} from "$app/navigation";
  import AuthForm from "./AuthForm.svelte";

  let loading = false

  const handleSignIn = async (email, password) => {
    try {
      loading = true

      const { user, session, error } = await supabase.auth.signIn({email, password}) // eslint-disable-line no-unused-vars

      if (error) {
	throw error
      }

      goto("/")
    }
    catch (error) {
      alert(error.error_description || error.message)
    }
    finally {
      loading = false
    }
  }
</script>

<AuthForm handler={handleSignIn} loading={loading} signup={false} />
